// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2iYHr","footer":"styles_footer__2Mmoz"};